<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="tads"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar color="white">
            <v-toolbar-title>Tad</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>

            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" max-width="500">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="tadnombre"
                          label="Nombre Completo del Tad"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-show="valida">
                        <v-row
                          class="red--text"
                          v-for="v in validamensaje"
                          :key="v"
                          v-text="v"
                        ></v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancelar</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="guardar"
                    >Guardar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="adModal" max-width="290">
              <v-card>
                <v-card-title class="headline" v-if="adAccion == 1"
                  >¿Activar Tad?</v-card-title
                >
                <v-card-title class="headline" v-if="adAccion == 2"
                  >¿Desactivar Tad?</v-card-title
                >
                <v-card-text>
                  Estás a punto de
                  <span v-if="adAccion == 1">Activar</span>
                  <span v-if="adAccion == 2">Desactivar</span>
                  el Tad {{ adNombre }}
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" @click="activarDesactivarCerrar"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    v-if="adAccion == 1"
                    color="orange darken-4"
                    @click="activar"
                    >Activar</v-btn
                  >
                  <v-btn
                    v-if="adAccion == 2"
                    color="orange darken-4"
                    @click="desactivar"
                    >Desactivar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon dense class="mr-2" @click="editItem(item)" v-on="on"
                >edit</v-icon
              >
            </template>
            <span>Editar Tad</span>
          </v-tooltip>

          <template v-if="item.tadestatus == 1">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon
                  dense
                  class="mr-2"
                  @click="ActivarDesactivarMostrar(2, item)"
                  v-on="on"
                  >block</v-icon
                >
              </template>
              <span>Desactivar </span>
            </v-tooltip>
          </template>
          <template v-else>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon
                  dense
                  class="mr-2"
                  @click="ActivarDesactivarMostrar(1, item)"
                  v-on="on"
                  >check</v-icon
                >
              </template>
              <span>Activar </span>
            </v-tooltip>
          </template>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="listar">Reset</v-btn>
        </template>
        <template v-slot:item.tadestatus="{ item }">
          <v-chip
            :color="getColor(item.tadestatus)"
            dark
            v-if="item.tadestatus == 1"
            >ACTIVO</v-chip
          >
          <v-chip
            :color="getColor(item.tadestatus)"
            dark
            v-if="item.tadestatus == 2"
            >SUSPENDIDO</v-chip
          >
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      // Variable de Imagen
      file: [],
      // Variable categoria
      tads: [],
      tadid:"",
      dialog: false,
      headers: [
        { text: "Operacion", value: "action", sortable: false },
        { text: "Nombre", value: "tadnombre" },
        { text: "Estatus", value: "tadestatus", sortable: false },
      ],
      search: "",
      editedIndex: -1,
      //
      tadnombre: "",
      usuarioid: "",

      valida: 0,
      validamensaje: [],
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      //
      dismissSecs: 5,
      dismissCountDown: 0,
      usuariocuenta: "",
      status: 0,
      rolid:"",
      rolselect: [],
      //

      data: [],

      
    };
  },
  // Crea una nueva categoria si es -1
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Tad" : "Actualizando Tad";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
  },

  //
  methods: {
    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    getColor(socioestatus) {
      if (socioestatus == 1) return "#3F8103"; // Verde
      if (socioestatus == 2) return "#DA0707"; // Rojo
    },
    // metodo listar
    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      axios
        .get("api/tads/listar", configuracion)
        .then(function (response) {
          me.tads = response.data.tad;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    // Actualiza la categotia
    editItem(item) {
      this.editedIndex = 1;
      this.dialog = true;
      this.tadnombre = item.tadnombre;
      this.tadid=item.tadid;
      this.usuarioid = item.usuarioid;
    },

    close() {
      this.reportes = false;
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.editedIndex = -1;
      this.tadnombre = "";
      this.tadid = "";
    },

    guardar() {
      if (this.validar()) {
        return;
      }

      var qs = require("qs");
      var data = qs.stringify({
        json:
          '{"tadnombre":"' +
          this.tadnombre +
          '","usuarioid":"' +
          this.$store.state.usuario.usuarioid +
          '"}',
      });

      if (this.editedIndex > -1) {
        //Editar
        let me = this;
        let header = { Authorization: this.$store.state.token };
        let configuracion = { headers: header };
        axios
          .put("api/tads/actualizar/"+me.tadid, data, configuracion)
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$swal("Tad Actualizada con Exito");
          })
          .catch(function (error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      } else {
        //Guardar
        let me = this;
        let header = { Authorization: this.$store.state.token };
        let configuracion = { headers: header };
        axios
          .post("api/tads/crear", data, configuracion)
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$swal("Tad Guardada con Exito");
          })
          .catch(function (error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      }
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];

      if (!this.tadnombre) {
        this.validamensaje.push("Ingrese Nombre Completo");
      }
      if (this.validamensaje.length) {
        this.valida = 1;
      }

      return this.valida;
    },

    ActivarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.usuarioid = item.usuarioid;
      this.adNombre = item.tadnombre;
      this.adId = item.idusuario;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },
    activar() {
      var qs = require("qs");
      var data = qs.stringify({
        json: '{"usuarioestatus":"1"}',
      });

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("api/usuarios/activar/" + this.usuarioid, data, configuracion)
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },
    desactivar() {
      var qs = require("qs");
      var data = qs.stringify({
        json: '{"usuarioestatus":"2"}',
      });

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("api/usuarios/activar/" + this.usuarioid, data, configuracion)
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },
  },
};
</script>